import { AzureBlobStore, FileServiceStore } from '../components/BaseFormFields/BaseFormFieldUpload/stores';

export const UPLOAD_STORAGES = {
  AZURE: AzureBlobStore,
  FILE_SERVICE: FileServiceStore,
};
